<template>
  <div>
    <el-table :data="pageData.items" height="480" stripe border :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
      <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed" :sortable="it.sortable" :sort-method="(a, b) => sortDateTime(a, b, it.key)">
        <template slot-scope="scope">
          <span v-if="it.key === 'device_name'">{{scope.row.device[it.key]}}</span>
          <span v-else>{{scope.row[it.key]}}</span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange"/>
  </div>
</template>

<script>
import Backend from '@/api/backend'
import Util from '@/api/util'

export default {
  name: '',
  data () {
    const deviceId = this.deviceId
    return Backend.initListPageNoCache(this, 'device_parameter_operate_recorder', {
      tableColList: [
        {
          key: 'operate_time',
          name: '操作时间',
          sortable: true
        },
        {
          key: 'user_name',
          name: '用户名'
        },
        {
          key: 'device_name',
          name: '设备名称'
        },
        {
          key: 'device_parameter_name',
          name: '参数'
        },
        {
          key: 'operate_content',
          name: '操作内容'
        }
      ],
      params: {
        device_id: deviceId
      }
    })
  },

  props: ['deviceId'],

  methods: {
    sortDateTime (a, b, key) {
      return Util.sortDateTime(a, b, key)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v, this.params)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page, this.params)
    }
  }
}
</script>
